<div class="map-cards" [class.map-cards--hidden]="objects.length === 0">
  <div class="map-cards__gradient"></div>

  <div
    class="map-cards__list-wrapper"
    (swipeleft)="next()"
    (swiperight)="previous()"
  >
    <ul class="map-cards__list">
      <li
        class="map-cards__item"
        *ngFor="let object of objects; trackBy: trackBy"
        [style.transform]="translateX"
      >
        <app-map-card [object]="object"></app-map-card>
      </li>
    </ul>

    <div class="map-cards__controls">
      <button
        class="map-cards__control map-cards__control--previous"
        (click)="previous()"
        [disabled]="isPreviousButtonDisabled"
      >
        <i
          class="map-cards__control-icon material-icon material-icon--outlined"
        >
          keyboard_arrow_left
        </i>
      </button>

      <button
        class="map-cards__control map-cards__control--next"
        (click)="next()"
        [disabled]="isNextButtonDisabled"
      >
        <i
          class="map-cards__control-icon material-icon material-icon--outlined"
        >
          keyboard_arrow_right
        </i>
      </button>
    </div>
  </div>
</div>
